<div class="billing-delivery-address-container">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <span class="spinner-border spinner-border-sm text-primary"></span>
    <small class="ms-2 text-muted">Loading addresses...</small>
  </div>

  <div *ngIf="!isLoading" class="row g-3">
    <!-- Billing Address -->
    <div class="col-12 col-md-6">
      <div class="card h-100">
        <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
          <small class="fw-bold d-flex align-items-center">
            <i class="bi bi-receipt me-1"></i> Billing Address
          </small>
          <button 
            type="button" 
            class="btn btn-sm btn-light btn-add-address"
            (click)="openAddAddressForm('billing')"
            *ngIf="!showBillingAddressForm"
            [disabled]="!canAddAddress()"
            [title]="!canAddAddress() ? 'Please select a master record first' : 'Add New Address'">
            <i class="bi bi-plus-circle"></i>
          </button>
        </div>
        <div class="card-body">
          <!-- Select Dropdown -->
          <form [formGroup]="billingAddressForm" *ngIf="!showBillingAddressForm">
            <div class="mb-2">
              <label class="form-label-sm">Select Address</label>
              <select class="form-select form-select-sm" formControlName="selectedAddressId">
                <option [value]="0">-- Select Address --</option>
                <option *ngFor="let addr of availableAddresses" [value]="addr.addressId">
                  {{ addr.addressType }} - {{ addr.address }}, {{ addr.city }}
                </option>
              </select>
            </div>
          </form>

          <!-- Show selected address details OR Add new address -->
          <div *ngIf="showBillingAddressForm || (billingAddressForm.get('selectedAddressId')?.value || 0) > 0">
            <app-uic-address-detail-view
              [addressId]="showBillingAddressForm ? 0 : (billingAddressForm.get('selectedAddressId')?.value || 0)"
              [masterType]="masterType"
              [masterId]="masterId"
              [isNewAddress]="showBillingAddressForm"
              (onAddressUpdate)="handleBillingAddressUpdate($event)"
              (onAddressCreated)="handleBillingAddressCreated($event)"
              (onCancelEdit)="closeAddAddressForm('billing')">
            </app-uic-address-detail-view>
          </div>
        </div>
      </div>
    </div>

    <!-- Delivery Address -->
    <div class="col-12 col-md-6">
      <div class="card h-100">
        <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
          <small class="fw-bold d-flex align-items-center">
            <i class="bi bi-truck me-1"></i> Delivery Address
          </small>
          <button 
            type="button" 
            class="btn btn-sm btn-light btn-add-address"
            (click)="openAddAddressForm('delivery')"
            *ngIf="!sameAsBilling && !showDeliveryAddressForm"
            [disabled]="!canAddAddress()"
            [title]="!canAddAddress() ? 'Please select a master record first' : 'Add New Address'">
            <i class="bi bi-plus-circle"></i>
          </button>
        </div>
        <div class="card-body">
          <div class="mb-2">
            <div class="form-check">
              <input 
                class="form-check-input" 
                type="checkbox" 
                id="sameAsBilling"
                [checked]="sameAsBilling"
                [disabled]="!isBillingAddressSelected()"
                (change)="onSameAsBillingChange($event)">
              <label class="form-check-label" for="sameAsBilling" [class.text-muted]="!isBillingAddressSelected()">
                Same as Billing Address
              </label>
            </div>
          </div>

          <!-- Select Dropdown -->
          <form [formGroup]="deliveryAddressForm" *ngIf="!sameAsBilling && !showDeliveryAddressForm">
            <div class="mb-2">
              <label class="form-label-sm">Select Address</label>
              <select class="form-select form-select-sm" formControlName="selectedAddressId">
                <option [value]="0">-- Select Address --</option>
                <option *ngFor="let addr of availableAddresses" [value]="addr.addressId">
                  {{ addr.addressType }} - {{ addr.address }}, {{ addr.city }}
                </option>
              </select>
            </div>
          </form>

          <!-- Add Address Form -->
          <div *ngIf="!sameAsBilling && showDeliveryAddressForm">
            <app-uic-address-detail-view
              [addressId]="0"
              [masterType]="masterType"
              [masterId]="masterId"
              [isNewAddress]="true"
              (onAddressCreated)="handleDeliveryAddressCreated($event)"
              (onCancelEdit)="closeAddAddressForm('delivery')">
            </app-uic-address-detail-view>
          </div>
          
          <!-- Show selected address details OR Add new address -->
          <div *ngIf="!showDeliveryAddressForm && !sameAsBilling && (deliveryAddressForm.get('selectedAddressId')?.value || 0) > 0">
            <app-uic-address-detail-view
              [addressId]="deliveryAddressForm.get('selectedAddressId')?.value || 0"
              [masterType]="masterType"
              [masterId]="masterId"
              (onAddressUpdate)="handleDeliveryAddressUpdate($event)">
            </app-uic-address-detail-view>
          </div>
          
          <!-- Show billing address when same as billing -->
          <div *ngIf="sameAsBilling && (billingAddressForm.get('selectedAddressId')?.value || 0) > 0">
            <app-uic-address-detail-view
              [addressId]="billingAddressForm.get('selectedAddressId')?.value || 0"
              [masterType]="masterType"
              (onAddressUpdate)="handleBillingAddressUpdate($event)">
            </app-uic-address-detail-view>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No addresses available message -->
  <div *ngIf="!isLoading && availableAddresses.length === 0 && !showBillingAddressForm && !showDeliveryAddressForm" class="alert alert-info mt-2">
    <i class="bi bi-info-circle me-1"></i> 
    <small>No addresses found. Click the <i class="bi bi-plus-circle"></i> button to add a new address.</small>
  </div>
</div>